export default "__VITE_ASSET__CiopdJkJ__"